import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const result = await login(username, password);
      if (!result || typeof result !== 'object') {
        setError('Login failed');
        return;
      }

      const user = result.user;
      const userRole = user && typeof user === 'object' ? user.role : undefined;

      if (result.success && userRole) {
        if (userRole === 'superadmin') {
          navigate('/superadmin');
        } else if (userRole === 'district_admin') {
          navigate('/district-admin');
        } else if (userRole === 'parent') {
          const gettingStartedDismissed = localStorage.getItem('gettingStartedDismissed');
          if (gettingStartedDismissed === 'true') {
            navigate('/parent/student-intake');
          } else {
            navigate('/parent/getting-started');
          }
        }
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err?.message || 'Login failed');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Back to School Forms</h1>
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn-primary">Login</button>
        </form>
        <div style={{ marginTop: '1rem', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <Link to="/forgot-username" style={{ color: '#667eea', textDecoration: 'none', fontSize: '0.9rem' }}>
            Forgot your username?
          </Link>
          <Link to="/forgot-password" style={{ color: '#667eea', textDecoration: 'none', fontSize: '0.9rem' }}>
            Forgot your password?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;

